var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"inline-input",attrs:{"value":_vm.formattedValue,"outlined":"","dense":"","hide-details":"","disabled":_vm.disabled},on:{"input":_vm.unformatValue,"keydown":_vm.preventNonNumericInput}})}
var staticRenderFns = []

export { render, staticRenderFns }